import { useContext, useEffect, useState } from "react"
import { DownloadSimple } from "@phosphor-icons/react"
import { Tag } from "antd"

import { SL_Modal } from "../../components/modal/Modal"
import { SL_Input } from "../../components/input/Input"
import { ModalTitle } from "./components/ModalTitle"

import { getData } from "../../helpers/helper"
import { displayMessage } from "../../helpers/messages"
import { GeneralContext } from "../../context/GeneralContext/GeneralContext"
import api from "../../services/api"

export const ActionReportModal = ({ report, onClose }) => {
    const { windowWidth, setShowLoading } = useContext(GeneralContext)
    const [reportData, setReportData] = useState(null)

    const getReportData = async () => {
        setShowLoading(true)
        try {
            const { data } = await api.monitorings.find(report.id)
            setReportData(data)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const dowloadAttachment = async ({id, name}) => {
        setShowLoading(true)
        try {
            const { data } = await api.attachments.getById(id)
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(data)
            link.download = name
            link.click()
            link.remove()
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    useEffect(() => {
        getReportData()
    }, [report])

    return (
        <SL_Modal
            open={true}
            title={
                <ModalTitle
                    onCloseButtonClick={onClose}
                    title={displayMessage('ACTION_REPORT', [reportData?.type_description])}
                    extraContent={(<div className="flex gap-[1.25vw] items-center">

                        <div className="flex flex-col gap-1 uppercase font-medium">
                            <span style={{ color: reportData?.AlertLog?.AlertType?.alert_color }} className="monitoring-report-modal-title-alert-type">
                                {reportData ? getData(reportData?.AlertLog?.AlertType?.alert_type, 'label') : null}
                            </span>
                            <span className="monitoring-report-modal-title-alert-label">{reportData?.device_name}</span>
                        </div>

                        <div className="flex flex-col items-end opacity-40">
                            <span className="monitoring-report-modal-title-alert-date">{reportData?.date}</span>
                            <span className="monitoring-report-modal-title-alert-date">{reportData?.minutes}</span>
                        </div>
                    </div>)}

                />}
            closable={false}
            closeIcon={null}
            footer={null}
            width={windowWidth * 0.7}
            bodyStyle={{
                padding: '2.22vh',
            }}
        >
            <SL_Input textarea={true} value={reportData?.general_description} rows={20} className='bg-sl-gray-150 text-white' disabled />

            {reportData?.Attachments?.length ?
                <div className="flex mt-2">
                    {reportData.Attachments.map(attachment =>
                        <Tag key={attachment.id} className="flex gap-1 items-center justify-center cursor-pointer" onClick={() => dowloadAttachment(attachment)}><DownloadSimple size={16} /> {attachment.name}</Tag>)}
                </div> : null}
        </SL_Modal>
    )
}